/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceContactWithDetails } from './ServiceContactWithDetails';
import {
    ServiceContactWithDetailsFromJSON,
    ServiceContactWithDetailsFromJSONTyped,
    ServiceContactWithDetailsToJSON,
} from './ServiceContactWithDetails';

/**
 * Payload of enumerated service contacts for a client organization
 * @export
 * @interface ServiceContactWithDetailsEnumeration
 */
export interface ServiceContactWithDetailsEnumeration {
    /**
     * 
     * @type {Array<ServiceContactWithDetails>}
     * @memberof ServiceContactWithDetailsEnumeration
     */
    items: Array<ServiceContactWithDetails>;
}

/**
 * Check if a given object implements the ServiceContactWithDetailsEnumeration interface.
 */
export function instanceOfServiceContactWithDetailsEnumeration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ServiceContactWithDetailsEnumerationFromJSON(json: any): ServiceContactWithDetailsEnumeration {
    return ServiceContactWithDetailsEnumerationFromJSONTyped(json, false);
}

export function ServiceContactWithDetailsEnumerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceContactWithDetailsEnumeration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ServiceContactWithDetailsFromJSON)),
    };
}

export function ServiceContactWithDetailsEnumerationToJSON(value?: ServiceContactWithDetailsEnumeration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ServiceContactWithDetailsToJSON)),
    };
}

